import React, { useEffect } from "react"

export const Register = ({ linkToAuth, signUp }) => {
  useEffect(() => {
    window.location.replace("https://my.denistiaglin.com/")
  }, [])

  return <div>loading...</div>
}
